import React from "react";
import { useLanguage } from "../../i18n";

const SolutionSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="solucion" className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="solution-section">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8">
              {t('solution.title')}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
                {t('solution.titleHighlight')}
              </span>
            </h2>
            <p className="text-lg text-gray-400 leading-relaxed">
              {t('solution.description')} <span className="text-cyan-400">{t('solution.mediaImpact')}</span>, <span className="text-cyan-400">{t('solution.viralContent')}</span> y <span className="text-cyan-400">{t('solution.brandRecall')}</span>.
            </p>
          </div>
          <div className="relative">
            <div className="aspect-video rounded-2xl overflow-hidden border border-white/10">
              <img 
                src="https://customer-assets.emergentagent.com/job_aerial-performance/artifacts/x0tumgw1_0E47EF9E-6D96-4B8B-A8EB-2D4D7232CF47.png" 
                alt="Experiencia NexAir"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full blur-3xl opacity-50" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
